import {
    Card,
    CardContent,
    Typography,
    Box,
    Chip,
    Grid,
    Stack,
    Divider,
    Button,
} from "@mui/material";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LayersIcon from '@mui/icons-material/Layers';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';

export default function TicketCard({ ticket, onView, onEdit, onDelete }) {
    if (!ticket) return null;

    return (
        <Card
            variant="outlined"
            sx={{
                mb: 1.5,
                borderRadius: 2,
                transition: "background-color 0.2s, box-shadow 0.2s",
                "&:hover": {  boxShadow: 3 },
                maxWidth : "min-content"
            }}
        >
            <CardContent sx={{ py: 1.5 }}>
                <Stack spacing={1.2}>
                    {/* Header */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography variant="subtitle1" fontWeight={600} noWrap>
                            {ticket.ticket_name}
                        </Typography>
                        <Chip
                            size="small"
                            label={ticket.ticket_status}
                            sx={{ textTransform: "capitalize" }}
                            color={
                                ticket.ticket_status === "completed"
                                    ? "success"
                                    : ticket.ticket_status === "in_progress"
                                    ? "warning"
                                    : "default"
                            }
                        />
                    </Box>

                    {ticket.ticket_description && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                            }}
                        >
                            {ticket.ticket_description}
                        </Typography>
                    )}

                    <Divider />

                    {/* Meta info */}
                    <Stack direction="column" spacing={1} mt={1}>
                        
                        <Box display="flex" alignItems="center" gap={0.8}>
                            <LibraryBooksOutlinedIcon
                                fontSize="small"
                                color="action"
                            />
                            <Box>
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Project
                                </Typography>
                                <Typography variant="body2">
                                    {ticket.project_name}
                                </Typography>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems="center" gap={0.8}>
                            <LayersIcon
                                fontSize="small"
                                color="action"
                            />
                            <Box>
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Route layer
                                </Typography>
                                <Typography variant="body2">
                                    {ticket.route_layer_name}
                                </Typography>
                            </Box>
                        </Box>
                        
                        <Box display="flex" alignItems="center" gap={0.8}>
                            <AssignmentIndOutlinedIcon
                                fontSize="small"
                                color="action"
                            />
                            <Box>
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Assigned by
                                </Typography>
                                <Typography variant="body2">
                                    {ticket.assigned_by_user_name}
                                </Typography>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems="center" gap={0.8}>
                            <PersonOutlineOutlinedIcon
                                fontSize="small"
                                color="action"
                            />
                            <Box>
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Assigned to
                                </Typography>
                                <Typography variant="body2">
                                    {ticket.assigned_to_user_name}
                                </Typography>
                            </Box>
                        </Box>

                        <Box display="flex" alignItems="center" gap={0.8}>
                            <EventOutlinedIcon
                                fontSize="small"
                                color="action"
                            />
                            <Box>
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                >
                                    Created
                                </Typography>
                                <Typography variant="body2">
                                    {new Date(
                                        ticket.ticket_created_at
                                    ).toLocaleDateString()}
                                </Typography>
                            </Box>
                        </Box>
                    </Stack>

                    <Divider />

                    {/* Action Buttons */}

                    <Stack
                        direction="row"
                        spacing={1}
                        mt={1}
                        justifyContent={"right"}
                    >
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<VisibilityOutlinedIcon />}
                            onClick={() => onView?.(ticket)}
                        >
                            View
                        </Button>
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={<EditOutlinedIcon />}
                            onClick={() => onEdit?.(ticket)}
                        >
                            Edit
                        </Button>
                        <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            startIcon={<DeleteOutlineOutlinedIcon />}
                            onClick={() => onDelete?.(ticket)}
                        >
                            Delete
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
